import { Show } from "solid-js";
import { PayoutInstrumentType } from "~/server/types/payout";

export function LoadingBankTransfer(props: {
  paymentMode: PayoutInstrumentType;
}) {
  return (
    <div class="relative flex h-full w-full flex-col items-start justify-start bg-baseTertiaryLight">
      <div class="mt-14 flex w-full flex-col items-center justify-between px-4 py-3">
        <p class="text-mediumBold uppercase text-textDark">Bank transfer</p>
        <p class="text-medium text-textNormal">Amount: ₹2,000</p>
      </div>
      <div class="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center ">
        <div class="h-[90px] w-[90px] animate-spin">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="91"
            height="90"
            viewBox="0 0 91 90"
            fill="none"
          >
            <path
              d="M90.5 45C90.5 69.8528 70.3528 90 45.5 90C20.6472 90 0.5 69.8528 0.5 45C0.5 20.1472 20.6472 0 45.5 0C70.3528 0 90.5 20.1472 90.5 45ZM8.6227 45C8.6227 65.3668 25.1332 81.8773 45.5 81.8773C65.8668 81.8773 82.3773 65.3668 82.3773 45C82.3773 24.6332 65.8668 8.1227 45.5 8.1227C25.1332 8.1227 8.6227 24.6332 8.6227 45Z"
              fill="#EDEEF1"
            />
            <path
              d="M45.5 4.03548C45.5 1.80675 43.6895 -0.0187886 41.4697 0.1808C33.3823 0.907967 25.6148 3.81347 19.0103 8.62287C11.3148 14.2267 5.59463 22.1267 2.67247 31.1869C-0.249682 40.247 -0.223306 50.0004 2.74781 59.0446C5.71892 68.0888 11.4817 75.9577 19.2074 81.5199C26.9332 87.082 36.2238 90.0508 45.7434 89.9993C55.2629 89.9479 64.5209 86.8787 72.1861 81.2333C79.8512 75.5879 85.5285 67.6571 88.4016 58.5813C90.8674 50.7922 91.1587 42.5042 89.2827 34.6038C88.7678 32.4354 86.4622 31.2976 84.3486 32.0046C82.235 32.7116 81.118 34.9961 81.5904 37.1742C82.9499 43.4441 82.6572 49.9849 80.707 56.1454C78.3492 63.5934 73.6901 70.1018 67.3998 74.7347C61.1094 79.3676 53.5119 81.8862 45.6997 81.9285C37.8876 81.9707 30.2632 79.5344 23.9231 74.9699C17.583 70.4053 12.8539 63.9477 10.4156 56.5256C7.97739 49.1035 7.95575 41.0995 10.3538 33.6643C12.7519 26.2292 17.446 19.7461 23.7614 15.1473C28.985 11.3434 35.0951 8.99089 41.4724 8.29122C43.6878 8.04816 45.5 6.26422 45.5 4.03548Z"
              fill="#313538"
            />
          </svg>
        </div>
        <Show
          when={props.paymentMode === "BANK"}
          fallback={<p class="mt-4 text-bold text-textDark">Verifying UPI</p>}
        >
          <p class="mt-4 text-bold text-textDark">Validating bank details</p>
        </Show>{" "}
        <p class="text-nowrap text-medium text-textNormal">
          We’ll send ₹1 to test your account
        </p>
      </div>
    </div>
  );
}
